import { createFileRoute } from "@tanstack/react-router";
import { LoginLinkPage } from "../pages/Login/LoginLink";

export const Route = createFileRoute("/login-link")({
  component: LoginLinkPage,
});
